export default __webpack_public_path__ + "static/media/body.1fefadfa.png";